module.exports = __webpack_public_path__ + "img/rules.48607c30.png";